import { render, staticRenderFns } from "./BBRAddressForm.vue?vue&type=template&id=c476e280&scoped=true&"
import script from "./BBRAddressForm.vue?vue&type=script&lang=js&"
export * from "./BBRAddressForm.vue?vue&type=script&lang=js&"
import style0 from "./BBRAddressForm.vue?vue&type=style&index=0&id=c476e280&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c476e280",
  null
  
)

export default component.exports